// extracted by mini-css-extract-plugin
module.exports = {"button":"SupportFab_button__3ZvJw","pulse":"SupportFab_pulse__3McDC","stopAnimation":"SupportFab_stopAnimation__SNalB"};